import { Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, forkJoin } from 'rxjs';
import { NotificationService } from 'src/app/Service/notification.service';
import { FilesService } from '../../../../Pages/files/files-api.service';
import { MyFamilyService } from 'src/app/User/Pages/my-family/my-family.service';
import { ShareLinkComponent } from '../sharelink/sharelink.component';
import { SharedFilesType } from 'src/app/Models/sharedFilesType';
import { GlobalConstants } from 'src/app/utils/global-constants';

@Component({
    selector: 'app-share-to-family',
    templateUrl: './shareToFamily.component.html',
    styleUrls: ['./shareToFamily.component.css'],
    standalone: false
})
export class ShareToFamilyComponent implements OnInit {
  form: UntypedFormGroup;
  @Input() fileid = '';
  @Input() folderId = '';
  @Input() creatorId = '';

  professionalInfo: any;
  subscriptions = new Subscription();
  sharedFilesType = SharedFilesType;
  currentLegacyVideoPageType: any = SharedFilesType.WhoFor;
  shareType: boolean;
  constructor(
    public fileDataService: FilesService,
    private fb: UntypedFormBuilder,
    public notify: NotificationService,
    private familyService: MyFamilyService,
    public modal: NgbModal,
    private activeModel: NgbActiveModal
  ) {}
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  goToReciepent(value: any) {
    this.currentLegacyVideoPageType = SharedFilesType.SelectReciepent;
    this.shareType = value;
  }
  ngOnInit(): void {
    this.GetProfessionalList();
    this.form = this.fb.group({
      email: [
        '',
        [Validators.required, Validators.pattern(GlobalConstants.emailPattern)],
      ],
      firstName: ['', Validators.required],
      userId: [''],
      lastName: ['', Validators.required],
      phoneNumber: [''],
    });
  }

  async sharelink(users: any) {
    const calls = [];
    users.forEach((user) => {
      calls.push(
        this.fileDataService.ShareToUser({
          fileId: this.fileid,
          userId: user?.id,
        })
      );
    });
    forkJoin(calls).subscribe((responses) => {
      if (responses && responses.every((x) => x?.data === true)) {
        this.modal.dismissAll();
        this.notify.showSuccess('File shared successfully');
      }
    });
  }
  async shareLinkTPA(professionals: any) {
    const calls = [];
    professionals.forEach((professional) => {
      calls.push(
        this.fileDataService.TPAFileShare({
          folderId: this.folderId,
          fileId: this.fileid,
          professional: professional?.id,
          creator: this.creatorId,
        })
      );
    });
    forkJoin(calls).subscribe((responses) => {
      if (responses && responses.every((x) => x?.data === true)) {
        this.modal.dismissAll();
        this.notify.showSuccess('File shared successfully');
      }
    });
  }

  GetProfessionalList() {
    this.subscriptions.add(
      this.familyService
        .GetProfessionalList(this.creatorId)
        .subscribe((res) => {
          this.professionalInfo = res.data;
        })
    );
  }
  goBack() {
    this.currentLegacyVideoPageType = SharedFilesType.WhoFor;
  }
  async shareToOther() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.activeModel.close();
      const dialogRef = this.modal.open(ShareLinkComponent, {
        centered: true,
        backdrop: 'static',
        keyboard: false,
      });
      dialogRef.componentInstance.fileid = this.fileid;
      dialogRef.componentInstance.otherIndividualsForm = this.form.value;
      return dialogRef.closed.toPromise().then((resp) => {
        this.modal.dismissAll();
        if (resp) this.notify.showSuccess('File shared successfully');
      });
    }
  }
  onClose() {
    this.modal.dismissAll();
  }
}
